import React from "react";
import logo from "../Assets/navlogo.png";

// import bg-pic from '../'

const Loading = () => {
  return (
    <div
      className={`  absolute bg-white h-screen w-full top-0 z-40 rounded-lg`}
    >
      <div className='flex items-center justify-center w-full h-full'>
        <img
          src={logo}
          alt=''
          className='h-14 animate-bounce transition ease-in-outduration-500'
        />
      </div>
    </div>
  );
};

export default Loading;
